module.exports = __webpack_public_path__ + "static/media/CheckBox.5a6ce837.svg";